// src/metadata/title.ts
const createTitle = () => ({ metadata }) => metadata.title;
export { createTitle };

//# sourceMappingURL=title.js.map